import { yupResolver } from '@hookform/resolvers/yup';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import React from 'react';
import { useForm } from 'react-hook-form';
import { IResettingPINCounterFormMeta } from '@Modules/cardManagementSystem/cardholder/containers/formHandler/cardOperations/ResettingPINCounterFormMeta';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import CustomInput from '@Modules/core/components/form/CustomInput';
import { CustomButton } from '@Modules/core/components';
import { FaRedo } from 'react-icons/fa';

type Props = {
    meta: IResettingPINCounterFormMeta,
} & TFormUIProps;

const ResettingPINCounterFormUI: React.FC<Props> = ({ onSubmit, isLoading, isSubmitting, meta }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
        <>
            <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
            <CC.SimpleGrid columns={{base: 1, md: 2}} spacing={10} my={4}>
              <CustomFormControl isLoading={isLoading} isInvalid={!!errors[meta.PAN.name]} label={meta.PAN.label}>
                <CustomInput hasError={errors[meta.PAN.name]} register={register(meta.PAN.name)} meta={meta['PAN']}/>
              </CustomFormControl>
              <CustomFormControl isLoading={isLoading} isInvalid={!!errors[meta.client.name]} label={meta.client.label}>
                <CustomInput hasError={errors[meta.client.name]} register={register(meta.client.name)} meta={meta['client']}/>
              </CustomFormControl>
            </CC.SimpleGrid>
              <CC.HStack my={4} justifyContent={'flex-end'}>
                <CustomButton isLoading={isSubmitting} type={'submit'}>
                  <FaRedo style={{ marginRight: '10px' }} /> Remettre à Zéro le Compteur PIN
                </CustomButton>
              </CC.HStack>
            </CC.Box>
        </>
  );
};

export default ResettingPINCounterFormUI;
